<template>
    <div class="relative post-preview col">
        <div class="post-create-inner">
            <div class="social-preview-buttons-wrap">
                <div class="social-preview-buttons-inner">
                    <SocialAccountChoice :key="index" v-for="(item, index) in accountPreviews" :variant="item.name" v-bind:class="{['mark-'+v[item.name].status]: v[item.name].status, 'previewing': item.active}" @click.native="showPreview(item)"/>
                </div>
            </div>

            <div class="width-100 relative">
                <component :errors="v[selectedPreview.name]" :post="post" v-bind:is="selectedPreview.component"></component>
                <div v-if="!selectedPreview">
                    <div class="break-after width-100 relative">
                        <p>No preview selected. Click on one of the icons above to preview your post.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Card from '../../../components/Card/Card';
    import SocialAccountChoice from '../../../components/SocialAccountChoice/SocialAccountChoice';
    import Toast from '../../../components/Toast/Toast';
    import Avatar from '../../../components/Avatar/Avatar'
    import LinkedIn from "./LinkedIn/LinkedIn";
    import Twitter from "./Twitter/Twitter";
    import Facebook from "./Facebook/Facebook";
    import Instagram from "./Instagram/Instagram";
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'Platforms',
        components: {
            Card,
            SocialAccountChoice,
            Toast,
            Avatar,
        },
        props: ['post'],
        data () {
            return {
                accountPreviews: [
                    {name: 'linkedin', component: LinkedIn, mark: 'danger', active: true},
                    {name: 'twitter', component: Twitter, mark: 'warning'},
                    {name: 'facebook', component: Facebook, mark: 'good'},
                    {name: 'instagram', component: Instagram, mark: 'good'}
                ],
            }
        },
        computed: {
            ...mapState({
                v: state => state.posts.valid
            }),
            selectedPreview: {
                // getter
                get: function () {
                    return this.accountPreviews.find(account=>{
                        return account.active;
                    })
                },
                // setter
                set: function (selectedAccount) {
                    this.accountPreviews = this.accountPreviews.map(account=>{
                        account.active = selectedAccount.name===account.name;
                        return account;
                    })
                }
            }
        },
        mounted () {
            this._validate(this.post);
        },
        methods: {
            ...mapActions('posts', [
                '_validate'
            ]),
            showPreview: function(account){
                this.selectedPreview = account;
            },

        }
    }
</script>
<style src="./Platforms.scss" scoped lang="scss"></style>
